import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const GuardianAIApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "GuardianAI" */ "./GuardianAIApp");
    return { default: namedExport.GuardianAIApp };
});

export const GuardianAI: TeamAppConfig = {
    title: "GuardianAI",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Run SmartTSG notebooks with guided parameters and browse the execution history for every notebook.",
    team: "RescueBoxFeatureCrew",
    publicId: "EXCHANGE\\RescueBoxFeatureCrew",
    owner: "rescueboxfeaturecrew@microsoft.com",
    role: "*",
    tags: [],
    app: GuardianAIApp,
    path: "/GuardianAI"
};
